import { type FC, type PropsWithChildren, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import type Enums from '@core/types/api/Enums';

interface PermissionGuardProps extends PropsWithChildren {
  permissions: Enums.Permission[];
}

export const PermissionGuard: FC<PermissionGuardProps> = ({ permissions, children }) => {
  const { userInfo } = useContext(SlabContext);

  if (userInfo.hasPermissions(permissions)) return children;

  return null;
};
